import { API } from '@/api';
import { mapToKey } from '@/utils/arrays';
import { filterBlanks } from '@/hooks/useStore/utils';

export const classes = {
  wrapper: 'w-full min-h-0 h-full overflow-y-auto',
};

export async function fetchInvestorData(investorId: number) {
  const pagination = { page: 1, pageSize: 100 }; // TODO: Pagination
  const data = await API.Investors.fetchCompaniesByInvestorId(investorId, {
    pagination,
  });
  return {
    financialReports: filterBlanks(
      mapToKey(data.results, 'latestFinancialReport')
    ),
    investorCompanies: mapToKey(data.results, 'investorCompany'),
    pagination: data.pagination,
  };
}
